import { Data, Model, Utils } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import InstrumentSearchCriteria from '../Instruments/Models/Queries/InstrumentSearchCriteria';
import { AppService, Types } from '../../App/Services/AppService';
import UpdateInstrumentCommand from '../Instruments/Models/Commands/UpdateInstrumentCommand';
import CommandResult from '../../Common/Models/CommandResult';
import CreateInstrumentCommand from '../Instruments/Models/Commands/CreateInstrumentCommand';
import InstrumentSearchLookup from '../../DataInterception/InstrumentMapping/Models/InstrumentSearchLookup';

export interface IInstrumentApiClient {
    createInstrument(command: Model.PlainObject<CreateInstrumentCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    getInstrumentLookupListByCriteria(criteria?: string): AxiosPromise<Array<Model.PlainObject<InstrumentSearchLookup>>>;
    getPagedInstruments(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<InstrumentSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<InstrumentSearchLookup>>>;
    updateInstrument(command: Model.PlainObject<UpdateInstrumentCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    getInstrumentLookupByID(staticInstrumentID: number): AxiosPromise<Model.PlainObject<InstrumentSearchLookup>>;
    getInstrumentLookupByISIN(ISIN: string): AxiosPromise<Model.PlainObject<InstrumentSearchLookup>>;
}

@injectable()
export default class InstrumentApiClient extends Data.ApiClientBase implements IInstrumentApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/Instrument`)
    }

    public createInstrument(command: Model.PlainObject<CreateInstrumentCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/CreateInstrument`, command);
    }

    public getInstrumentLookupListByCriteria(criteria: string = ""): AxiosPromise<Array<Model.PlainObject<InstrumentSearchLookup>>> {
        return this.axios.get(`${this.apiPath}/GetInstrumentLookupListByCriteria`, { params: { criteria: criteria } });
    }

    public getInstrumentLookupByISIN(ISIN: string): AxiosPromise<Model.PlainObject<InstrumentSearchLookup>>
    {
        return this.axios.get(`${this.apiPath}/GetInstrumentLookupByISIN`, { params: { ISIN: ISIN }});
    }

    public getPagedInstruments(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<InstrumentSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<InstrumentSearchLookup>>> {
        var response = this.axios.get(`${this.apiPath}/GetInstrumentLookup?${Utils.getQueryString(payload)}`);
        return response;
    }

    public updateInstrument(command: Model.PlainObject<UpdateInstrumentCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/UpdateInstrument`, command);
    }

    public getInstrumentLookupByID(staticInstrumentID: number): AxiosPromise<Model.PlainObject<InstrumentSearchLookup>> {
        var response = this.axios.get(`${this.apiPath}/GetInstrumentLookupByID`, { params: { instrumentID: staticInstrumentID }});
        return response;
    }
}